import { render } from "./CotizadorWrapper.vue?vue&type=template&id=1302aa68"
import script from "./CotizadorWrapper.vue?vue&type=script&lang=js"
export * from "./CotizadorWrapper.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__